import * as React from "react"
import ReactPaginate from "react-paginate"

import { IconButton } from "@walmart-web/livingdesign-components"
import * as Icon from "@walmart-web/livingdesign-icons"

import { DEFAULT_PAGE_RANGE, MID_PAGE_LABEL, NO_PAGES } from "./constants"
import { PaginatorProps } from "./interfaces"

import "./Paginator.scss"

const Paginator: React.FC<PaginatorProps> = (props) => {
	const {
		pageCount,
		onPageChange,
		pageRangeDisplayed = DEFAULT_PAGE_RANGE,
		...otherProps
	} = props

	const hasNoPages = pageCount === NO_PAGES
	if (hasNoPages) {
		return null
	}

	return (
		<ReactPaginate
			className="paginator"
			disabledClassName="navigation-button-disabled"
			breakLabel={MID_PAGE_LABEL}
			pageCount={pageCount}
			nextLabel={
				<IconButton
					a11yLabel="icon"
					size="large"
					UNSAFE_className="navigation-button"
				>
					<Icon.ChevronRight />
				</IconButton>
			}
			previousLabel={
				<IconButton
					a11yLabel="icon"
					size="large"
					UNSAFE_className="navigation-button"
				>
					<Icon.ChevronLeft />
				</IconButton>
			}
			onPageChange={onPageChange}
			marginPagesDisplayed={1}
			pageRangeDisplayed={pageRangeDisplayed}
			{...otherProps}
		/>
	)
}

export default Paginator
